/**
 * returns whether the string ItemClass corresponds to a Message
 */
const isItemClassOfMessageType = (itemClass: string) =>
    itemClass &&
    ['IPM.Note', 'IPM.Schedule.Meeting', 'IPM.GroupMailbox.JoinRequest', 'IPM.Post'].includes(
        itemClass
    );

export default isItemClassOfMessageType;
